<template>
    <span
        v-if="normalizedItems.length"
        class="limited-badge-list"
        :title="fullText"
    >
        <b-badge
            v-for="(item, index) in visibleItems"
            :key="itemKey(item, index)"
            :variant="variant"
            class="limited-badge-list__item"
        >
            {{ item.label }}
        </b-badge>
        <b-badge
            v-if="hiddenItemsCount > 0"
            :variant="overflowVariant"
            class="limited-badge-list__overflow"
        >
            +{{ hiddenItemsCount }}
        </b-badge>
    </span>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    name: 'LimitedBadgeList',
    components: { BBadge },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        limit: {
            type: Number,
            default: 3,
        },
        variant: {
            type: String,
            default: 'light-secondary',
        },
        overflowVariant: {
            type: String,
            default: 'light-secondary',
        },
        itemLabel: {
            type: Function,
            default: null,
        },
    },
    computed: {
        normalizedItems() {
            return this.items
                .map((item, index) => ({
                    item,
                    index,
                    label: this.resolveLabel(item),
                }))
                .filter(item => item.label !== '')
        },
        visibleItems() {
            return this.normalizedItems.slice(0, Math.max(0, this.limit))
        },
        hiddenItemsCount() {
            return Math.max(this.normalizedItems.length - this.visibleItems.length, 0)
        },
        fullText() {
            return this.normalizedItems.map(item => item.label).join(', ')
        },
    },
    methods: {
        resolveLabel(item) {
            if (this.itemLabel) {
                return this.normalizeLabel(this.itemLabel(item))
            }
            if (item && typeof item === 'object') {
                return this.normalizeLabel(item.title || item.name || item.label || item.value)
            }
            return this.normalizeLabel(item)
        },
        normalizeLabel(value) {
            return value === null || typeof value === 'undefined' ? '' : String(value)
        },
        itemKey(item, index) {
            const value = item.item
            if (value && typeof value === 'object' && value.id !== null && typeof value.id !== 'undefined') {
                return `item-${value.id}`
            }
            return `item-${item.index}-${index}-${item.label}`
        },
    },
}
</script>

<style lang="scss" scoped>
.limited-badge-list {
    display: inline-flex;
    flex-wrap: wrap;
    gap: .35rem;

    &__item,
    &__overflow {
        font-weight: 500;
        white-space: normal;
    }
}
</style>
